// extracted by mini-css-extract-plugin
export default {"root":"_3jjk_","align-items-center":"_1mWO8","alignItemsCenter":"_1mWO8"};